import script from "./SaveButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveButton.vue?vue&type=script&setup=true&lang=js"

import "./SaveButton.vue?vue&type=style&index=0&id=61d3b062&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d3b062"]])

export default __exports__